import { render, staticRenderFns } from "./SecAdvContent.vue?vue&type=template&id=8e18e1e2"
import script from "./SecAdvContent.vue?vue&type=script&lang=js"
export * from "./SecAdvContent.vue?vue&type=script&lang=js"
import style0 from "./SecAdvContent.vue?vue&type=style&index=0&id=8e18e1e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports